/**
 * sanitizeQuery — MUTATES the given URLSearchParams IN PLACE.
 * Side effects:
 *  - modifies the `params` instance (deletes UTM);
 *  - writes UTM data to localStorage under the "utm" key.
 *
 * @param {URLSearchParams} params The instance to sanitize (WILL BE MUTATED).
 * @returns {URLSearchParams} The same `params` instance (for convenience).
 */
export function sanitizeQuery(params) {
    const utmData = {};

    for (const [key, value] of params.entries()) {
        if (key.toLowerCase().startsWith("utm_")) {
            utmData[key] = value;   // сохраняем только utm
            params.delete(key);
            continue;
        }
        if (key === "_gl") {
            params.delete(key);     // _gl удаляем, но не сохраняем
        }
    }

    // сохраняем в localStorage
    if (Object.keys(utmData).length) {
        try {
            const prev = JSON.parse(localStorage.getItem("utm") || "{}");
            localStorage.setItem("utm",JSON.stringify({ ...prev, ...utmData, ts: Date.now() }));
        } catch {
            // environments без localStorage
        }
    }

    return params;
}
